var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.changeType === 0 ? "修改密码" : "密码到期请修改",
        visible: _vm.changeVisible,
        width: "700px",
        "close-on-click-modal": false,
        "show-close": false,
        "append-to-body": true,
        modal: true,
        center: ""
      },
      on: {
        "update:visible": function($event) {
          _vm.changeVisible = $event
        }
      }
    },
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          staticStyle: { width: "500px", "margin-left": "50px" },
          attrs: {
            rules: _vm.rules,
            model: _vm.dataForm,
            "status-icon": "",
            "label-position": "left",
            "label-width": "100px"
          }
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "原密码", prop: "oldPassword" } },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  placeholder: "请输入账号原登录密码"
                },
                model: {
                  value: _vm.dataForm.oldPassword,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "oldPassword", $$v)
                  },
                  expression: "dataForm.oldPassword"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "新密码", prop: "newPassword" } },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  placeholder:
                    "至少6位，包含大写字母、小写字母、数字、特殊字符",
                  "auto-complete": "off"
                },
                model: {
                  value: _vm.dataForm.newPassword,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "newPassword", $$v)
                  },
                  expression: "dataForm.newPassword"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "确认密码", prop: "newPassword2" } },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  placeholder:
                    "至少6位，包含大写字母、小写字母、数字、特殊字符",
                  "auto-complete": "off"
                },
                model: {
                  value: _vm.dataForm.newPassword2,
                  callback: function($$v) {
                    _vm.$set(_vm.dataForm, "newPassword2", $$v)
                  },
                  expression: "dataForm.newPassword2"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _vm.changeType === 0
            ? _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.change } },
            [_vm._v("修改密码")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }